import { Button, Flex, Image, Text } from '@chakra-ui/react';
import { FiCheckSquare, FiGrid } from 'react-icons/fi';
import { useStepPhotoManager } from '../../../../contexts/StepPhotoManagerContext';
import { Link } from 'react-router-dom';
import { PageTransition } from '../../../../components/PageTransition';

export function InitialStep() {
  const { dispatch } = useStepPhotoManager();

  return (
    <PageTransition>
      <Image src="https://via.placeholder.com/430x440" alt="Placeholder" w="100%" />

      <Flex flexDir="column" alignItems="center" p="32px" color="#1C2126" gap="39px">
        <Text fontSize="22px" textAlign="center">
          Para qual finalidade você deseja enviar os arquivos?
        </Text>

        <Button
          w="full"
          bg="#80BC00"
          color="white"
          rightIcon={<FiCheckSquare size={24} />}
          as={Link}
          to="/adm/photo-manager/fotos-para-pedido">
          Fotos para Pedido
        </Button>
        <Button
          w="full"
          bg="#414042"
          color="white"
          rightIcon={<FiGrid size={24} />}
          as={Link}
          to="/adm/photo-manager/fotos-para-galeria">
          Fotos para Galeria
        </Button>
      </Flex>
    </PageTransition>
  );
}
